module.exports = __webpack_public_path__ + "static/media/proj20_img14.162a9a83.jpg";